import {GridFilterModel} from "@mui/x-data-grid-pro";

export const muiGridFilterIsValid = (model: GridFilterModel) => {
        const emptyOperators = ["isEmpty", "isNotEmpty"]
        for (const fltr of model.items) {
            if (
                !fltr.operatorValue ||
                (
                    emptyOperators.indexOf(fltr.operatorValue) < 0 &&
                    (
                        fltr.value === undefined ||
                        (Array.isArray(fltr.value) && fltr.value.length ===0)
                    )
                )
            ) {
                return false;
            }
        }
        return true;
    }